import styled from "@emotion/styled";
import { Modal } from "antd";

const ModalStyled = styled(Modal)`
   .ant-modal-content {
    padding: 29px 18px
   } 
`;
export default ModalStyled;
